module.exports = __webpack_public_path__ + "img/blog-1.a0bbf14e.jpg";